import { connect } from 'react-redux';
import RemoveCommissionModal from "./RemoveCommissionModal";
import {getActiveModal, hideModal, MODAL_REMOVE_COMMISSION} from "../../../../reducers/common/activeModal";
import {resetSubmitFormData} from "../../../../reducers/common/submitForm";
import {getTranslation} from "../../../../reducers/common/localization";
import {
    getCommissionToRemove, removeCommission,
    setCommissionToRemove
} from "../../../../reducers/commission/commissions";

const mapStateToProps = state => {
    return {
        isOpen: getActiveModal(state).modalKey === MODAL_REMOVE_COMMISSION,
        data: getCommissionToRemove(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCancel: () => {
            dispatch(hideModal());
            dispatch(resetSubmitFormData());
            dispatch(setCommissionToRemove(null));
        },
        onCommissionRemove: () => {
            dispatch(removeCommission())
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RemoveCommissionModal);



// WEBPACK FOOTER //
// ./src/components/paymentManagement/commissionsModal/removeCommissionModal/RemoveCommissionModal.container.js